import { combineReducers } from 'redux';

import billingReducer from './billing/reducer';
import employersReducer from './employers/reducer';
import grantsReducer from './grants/reducer';
import groupsReducer from './groups/reducer';
import hiringEventsReducer from './hiringEvents/reducer';
import hubsReducer from './hubs/reducer';
import jobGroupsReducer from './jobGroups/reducer';
import jobManageReducer from './jobManage/reducer';
import jobsReducer from './jobs/reducer';
import notificationsReducer from './notifications/reducer';
import profilesReducer from './profiles/reducer';
import subOrganizationsReducer from './subOrganizations/reducer';
import jobCampaignsReducer from './jobCampaigns/reducer';
import campaignAnalyticsReducer from './campaignAnalytics/reducer';
import dashboardReducer from './dashboard/reducer';

export default combineReducers({
  billing: billingReducer,
  campaignAnalytics: campaignAnalyticsReducer,
  dashboard: dashboardReducer,
  employers: employersReducer,
  grants: grantsReducer,
  groups: groupsReducer,
  hiringEvents: hiringEventsReducer,
  hubs: hubsReducer,
  jobCampaigns: jobCampaignsReducer,
  jobGroups: jobGroupsReducer,
  jobManage: jobManageReducer,
  jobs: jobsReducer,
  notifications: notificationsReducer,
  profiles: profilesReducer,
  subOrganizations: subOrganizationsReducer,
});
